"use client";

import { useState } from "react";

export default function FaqAccordion({
  faqs,
}: {
  faqs: readonly { q: string; a: string }[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="divide-y divide-navy/10 border-y border-navy/10">
      {faqs.map(({ q, a }, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={q}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full cursor-pointer items-center justify-between gap-13 py-21 text-left text-sm font-semibold text-navy transition-colors hover:text-navy/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-gold lg:text-base"
            >
              {q}
              <span
                aria-hidden="true"
                className={`shrink-0 text-gray-400 transition-transform duration-200 ease-in-out ${isOpen ? "rotate-45" : ""}`}
              >
                +
              </span>
            </button>
            {/* aria-hidden keeps the SR a11y tree consistent with the
                button's aria-expanded state — collapsed answers stay in
                the DOM (so the FAQPage JSON-LD on the page reflects what's
                actually present) but are skipped by assistive tech until
                expanded. */}
            <div
              aria-hidden={!isOpen}
              className={`grid transition-[grid-template-rows] duration-200 ease-in-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
            >
              <div className="overflow-hidden">
                {/* max-w caps the measure — desktop accordion columns run
                    ~790px, which at this size is 100+ chars per line. */}
                <p className="max-w-[70ch] pb-21 text-sm leading-relaxed text-gray-600 lg:text-[15px]">
                  {a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
